// extracted by mini-css-extract-plugin
export default {"headerStatus":"search_header_status-module__headerStatus--3UkVB"};